import React, { PropTypes } from 'react';
import bemHelper from 'react-bem-helper';
import { Element } from 'react-scroll';

import * as constants from '../../constants';
import ReviewsModule from '../ReviewsModule/ReviewsModule';
import CommentsModule from '../CommentsModule/CommentsModule';

import './styles.scss';

const bem = bemHelper({ prefix: 'toga-', name: 'storefront-comments-grid' });

export default class CommentsGrid extends React.Component {

  render() {
    const { comments, reviews } = this.props;

    const countComments = (comments || []).length;
    const countReviews = (reviews || []).length;
    const total = countComments + countReviews;
    const isEmpty = countComments === 0 && countReviews === 0;
    const hasWrap = (total === constants.TOTAL_VISIBLE_COMMENTS_REVIEWS && !isEmpty);
    const gridWrap = total === 2 && !isEmpty;

    const classes = {
      'no-wrap': hasWrap || gridWrap,
      wrap: !hasWrap && !gridWrap,
    };

    return (
      <Element {...bem(null, classes)} name="grid">
        {countReviews > 0 && <ReviewsModule hasWrap={hasWrap}
                                            reviews={reviews}
                                            gridWrap={gridWrap}/>}
        {countComments > 0 && <CommentsModule hasWrap={hasWrap}
                                              comments={comments}
                                              gridWrap={gridWrap}/>}
      </Element>
    );
  }
}

CommentsGrid.PropTypes = {
  comments: PropTypes.array,
  reviews: PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/components/storefront/components/CommentsGrid/CommentsGrid.js